import { ComplianceOverviewPage } from "@/components/compliance/compliance-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

// Deliberately outside /settings/org: the compliance overview is readable by
// non-admins as well, matching the previous /dashboard/compliance behaviour.
export const Route = createFileRoute("/_authenticated/settings/compliance")({
	component: ComplianceRouteComponent,
	validateSearch: z.object({
		q: z.string().optional(),
	}),
	head: () => ({
		meta: [{ title: pageTitle(m.compliance_title()) }],
	}),
});

function ComplianceRouteComponent() {
	const { q } = Route.useSearch();
	return <ComplianceOverviewPage initialSearch={q} />;
}
